export const brand: { [color: string]: string } = {
  red: '#F54146',
  orange: '#FF6836',
  yellow: '#F0DC28',
  green: '#00D383',
  blue: '#7CCDD7',
  pink: '#FF87b4',
  white: '#FFFFFF',
  grey: '#F0F0ED',
  black: '#000000',
};

export const extended: { [color: string]: { [shade: string]: string } } = {
  red: {
    shade100: '#FbADb0',
    shade200: '#FA8285',
    shade300: '#F66468',
    shade400: brand.red,
    shade500: '#D23A3E',
    shade600: '#A72b2F',
    shade700: '#872124',
  },
  orange: {
    shade100: '#FFC8b6',
    shade200: '#FFA98C',
    shade300: '#FF835A',
    shade400: brand.orange,
    shade500: '#E55D30',
    shade600: '#C04C26',
    shade700: '#A44323',
  },
  yellow: {
    shade100: '#FCF8D1',
    shade200: '#F4E76D',
    shade300: '#F1E046',
    shade400: brand.yellow,
    shade500: '#D6C423',
    shade600: '#A1941C',
    shade700: '#775F0b',
  },
  green: {
    shade100: '#DAF4EA',
    shade200: '#54D8A6',
    shade300: '#18D88F',
    shade400: brand.green,
    shade500: '#02b671',
    shade600: '#027E4F',
    shade700: '#013421',
  },
  blue: {
    shade100: '#C8DEE1',
    shade200: '#b6D4D8',
    shade300: '#91D1D9',
    shade400: brand.blue,
    shade500: '#76C3CC',
    shade600: '#67AAb2',
    shade700: '#4E8389',
  },
  pink: {
    shade100: '#F4C3D6',
    shade200: '#F4A1C0',
    shade300: '#FF99bF',
    shade400: brand.pink,
    shade500: '#F482AD',
    shade600: '#E06E99',
    shade700: '#b95178',
  },
};

export const grayscale: { [color: string]: string } = {
  shade100: brand.white,
  shade200: '#FAFAF9',
  shade300: '#F7F7F4',
  shade400: brand.grey,
  shade500: '#E1E1Db',
  shade600: '#C3C3bA',
  shade700: '#A2A292',
  shade800: '#7A7A68',
  shade900: '#4F4F42',
  shade1000: '#2C2C25',
  shade1100: brand.black,
};
